import api from './client';
import { AuthResponse } from '../types';

export const meApi = {
  getMe: () => api.get<AuthResponse>('/api/me'),
  uploadAvatar: (file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post<AuthResponse>('/api/me/avatar', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  deleteAvatar: () => api.delete<AuthResponse>('/api/me/avatar'),
};
